import notificationService from '../services/notificationService';
import { NOTIFICATION_ACTION_TYPES } from './types';

/**
 * Fetch notification count action - Redux dispatch format
 * This action should only be called when:
 * 1. Component mounts (initial load)
 * 2. New activity/notification is received via WebSocket
 * @returns {Function} Thunk action
 */
/**
 * @param {{ skipActivitySync?: boolean }} [options]
 * skipActivitySync — do not bump syncRevision (avoids refetching Activity right after bulk mark-viewed).
 */
export const fetchNotificationCount = (options = {}) => async (dispatch) => {
  dispatch({ type: NOTIFICATION_ACTION_TYPES.FETCH_NOTIFICATION_COUNT_REQUEST });

  try {
    const response = await notificationService.getNotificationCount();

    if (response.success) {
      dispatch({
        type: NOTIFICATION_ACTION_TYPES.FETCH_NOTIFICATION_COUNT_SUCCESS,
        payload: {
          count: response.data.count || 0,
          skipActivitySync: !!options.skipActivitySync,
        },
      });
      return {
        success: true,
        data: response.data,
      };
    }
    dispatch({
      type: NOTIFICATION_ACTION_TYPES.FETCH_NOTIFICATION_COUNT_FAILURE,
      payload: response.message || 'Failed to fetch notification count',
    });
    return {
      success: false,
      error: response.message || 'Failed to fetch notification count',
    };
  } catch (error) {
    dispatch({
      type: NOTIFICATION_ACTION_TYPES.FETCH_NOTIFICATION_COUNT_FAILURE,
      payload: error.message || 'An unexpected error occurred',
    });
    return {
      success: false,
      error: error.message || 'An unexpected error occurred',
    };
  }
};

/** Hide activity footer badge immediately when opening Activity (poll/API may lag). */
export const clearNotificationCount = () => ({
  type: NOTIFICATION_ACTION_TYPES.CLEAR_NOTIFICATION_COUNT,
});
